import CustomButton from "@/components/common/Button";
import { NotFoundProps } from "@/utils/types/notFound";
import { Result } from "antd";
import { ArrowLeft, FileQuestion, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC<NotFoundProps> = ({
  title,
  subtitle,
  entityName = "Item",
  showBackButton = true,
  showHomeButton = true,
  onBack,
  onHome,
  className = "",
}) => {
  const navigate = useNavigate();

  const defaultTitle = title ?? `${entityName} Not Found`;
  const defaultSubtitle =
    subtitle ??
    `The ${entityName.toLowerCase()} you're looking for doesn't exist or has been removed.`;

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleHome = () => {
    if (onHome) {
      onHome();
    } else {
      navigate("/home");
    }
  };

  const extraButtons = [];

  if (showBackButton) {
    extraButtons.push(
      <CustomButton
        key="back"
        icon={<ArrowLeft size={16} />}
        onClick={handleBack}
        title="Navigate Back"
      >
        Go Back
      </CustomButton>
    );
  }

  if (showHomeButton) {
    extraButtons.push(
      <CustomButton
        key="home"
        type="primary"
        icon={<Home size={16} />}
        onClick={handleHome}
        title="Navigate to Home"
      >
        Go Home
      </CustomButton>
    );
  }

  return (
    <div
      className={`flex h-screen items-center justify-center md:h-[calc(100vh-200px)] ${className}`}
    >
      <Result
        icon={<FileQuestion size={64} className="text-gray-400" />}
        title={defaultTitle}
        subTitle={defaultSubtitle}
        extra={extraButtons}
        status="404"
      />
    </div>
  );
};

export default NotFound;
